import moment from 'moment';
import bowser from 'bowser';

export const roundToPreviousPeriod = (time, periodLengthMinutes) => {
    return moment(time)
        .startOf(`h`)
        .add(Math.floor(time.minute() / periodLengthMinutes) * periodLengthMinutes, `m`);
};

export const roundToNextPeriod= (time, periodLengthMinutes) => {
    return moment(time)
        .startOf(`h`)
        .add(Math.ceil(time.minute() / periodLengthMinutes) * periodLengthMinutes, `m`);
};

// Helper function that provides ability to delay for x milliseconds.
// Like: http://bluebirdjs.com/docs/api/promise.delay.html
export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const isHomescreenLaunch = () => {
    const iOsHomescreen = (window.navigator.standalone === false);
    const androidHomescreen = window.matchMedia(`(display-mode: standalone)`).matches;

    return iOsHomescreen || androidHomescreen;
};

export const supportsVideoAutoPlay = () => {
    if (bowser.mobile) {
        if (bowser.ios && (bowser.compareVersions([bowser.osversion, `10.0`]) < 0 || bowser.firefox)) {
            return false;
        } else if (bowser.windowsphone) {
            return false;
        } else if (bowser.android) {
            if (bowser.firefox && !bowser.check({ firefox: `49` }))
                return false;
            else if (bowser.chrome && !bowser.check({ chrome: `54` }))
                return false;
        }
    }

    return true;
};



// WEBPACK FOOTER //
// ./scripts/util/index.js